import { useEffect, type ReactNode } from "react";
import { useAuth } from "./OidcProvider";

// Wraps any route that requires an authenticated user. If unauthenticated,
// kicks off the OIDC code flow against Nova OS. While the redirect is in
// flight, renders a minimal "Signing in…" placeholder so the previous
// page doesn't flash.
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { state, signIn } = useAuth();

  useEffect(() => {
    if (state.status === "unauthenticated") {
      void signIn();
    }
  }, [state.status, signIn]);

  if (state.status === "authenticated") return <>{children}</>;
  return (
    <div className="flex h-screen items-center justify-center text-slate-500">
      Signing in…
    </div>
  );
}
